<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "RefineGlyphModal",
  components: {
    ModalWrapperChoice
  },
  props: {
    idx: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      resourceAmount: 0,
      resourceUnlocked: false,
      gain: 0,
      after: 0,
      cap: 0,
      confirmedRefine: false
    };
  },
  computed: {
    glyph() {
      return Glyphs.findByInventoryIndex(this.idx);
    },
    resource() {
      return GlyphSacrificeHandler.glyphAlchemyResource(this.glyph);
    },
    resourceName() {
      return this.resource.name;
    },
  },
  methods: {
    update() {
      const resource = this.resource;
      this.resourceAmount = resource.amount;
      this.resourceUnlocked = resource.isUnlocked;
      this.gain = GlyphSacrificeHandler.glyphRefinementGain(this.glyph);
      this.cap = GlyphSacrificeHandler.glyphEffectiveCap(this.glyph);

      this.after = this.resourceAmount + this.gain;

      const newGlyph = Glyphs.findByInventoryIndex(this.idx);
      if (this.glyph !== newGlyph && !this.confirmedRefine) {

        // Why is confirmedRefine here: refer to SacrificeGlyphModal.vue

        this.emitClose();
        Modal.message.show("Выбранный Глиф изменил позицию или был как-либо иначе изменён!");
      }
    },
    handleYesClick() {
      this.confirmedRefine = true;
      GlyphSacrificeHandler.refineGlyph(this.glyph);
    },
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="glyphRefine"
    @confirm="handleYesClick"
  >
    <template #header>
      Вы собираетесь Переработать Глиф
    </template>
    <div
      v-if="resourceUnlocked"
      class="c-modal-message__text"
    >
      Переработка Глифа удалит Глиф из вашего инвентаря, и, взамен,
      повысит ваш {{ resourceName }} Алхимический ресурс с
      {{ format(resourceAmount, 2, 2) }} до {{ format(after, 2, 2) }}.
      Этот Глиф может поднять ваш {{ resourceName }} ресурс до максимум {{ format(cap, 2, 2) }}.
    </div>
    <div
      v-else
      class="c-modal-message__text"
    >
      Вы не можете получить ни одного {{ resourceName }} алхимического ресурса, потому что вы ещё не
      разблокировали ресурс этого Глифа. Вы всё равно можете его Переработать, но ничего
      не произойдёт. Вместо этого, подумайте о Жертвовании данного Глифа.
    </div>
  </ModalWrapperChoice>
</template>
